import { SvgIcon } from '@mui/material';
import { memo } from 'react';

function ConsolidationFlowIcon({ ...props }) {
  return (
    <SvgIcon width='24' height='24' {...props}>
      <path
        d='M9.00015 16.5048C7.75784 16.5048 7.00019 16.5048 4.5002 16.5048C4.49978 15.0048 4.50015 13.2471 4.50015 12.0048C4.50015 10.7624 4.5 9.00546 4.50015 7.50567C5.5 7.50477 7.75784 7.50477 9.00015 7.50477C10.1655 7.50477 11.8079 7.51172 13.3079 7.5C13.3079 9.01172 13.3079 10.5117 13.3079 11.5117L19.3674 11.5048L17.2732 9.40477L17.9809 8.67784L21.3079 12.0048L17.9809 15.3125L17.2674 14.5855L19.3674 12.5048L13.3079 12.5117C13.3079 13.5117 13.3079 15.0048 13.3079 16.5048C12.3079 16.5048 10.1655 16.5048 9.00015 16.5048ZM9.00015 15.5048C9.96167 15.5048 11.3079 15.5117 12.3079 15.5048C12.3079 14.5117 12.3079 12.9733 12.3079 12.0117C12.3079 11.0502 12.3079 10.0117 12.3079 8.51172C11.3079 8.51172 9.96167 8.50477 9.00015 8.50477C8.03862 8.50477 6.30786 8.51172 5.30786 8.51172C5.30786 9.51172 5.30786 11.0502 5.30786 12.0117C5.30786 12.9733 5.30786 14.5117 5.30786 15.5117C6.30786 15.5117 8.03862 15.5048 9.00015 15.5048Z'
        stroke='none'
        fill='currentColor'
      />
    </SvgIcon>
  );
}

export default memo(ConsolidationFlowIcon);
